export function hasModernPreviewAccess(user = {}) {
  return Boolean(user && (user.is_admin_user || user.is_developer_user));
}
